import React from "react";
import { Outlet } from "react-router-dom";
import "../assets/css/InBody.scss";

const RootContainer = () => {
  return (
    <>
      <div className="panel-container">
        <div className="panel">
          <div className="logo-container"></div>
          <div className="halo-gradient"></div>
          <div className="background-image"></div>
          <div className="panel-inner">
            <h1 style={{ textAlign: "center" }}>
              {process.env.NODE_ENV === "development"
                ? process.env.NODE_ENV.toUpperCase()
                : ""}
            </h1>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default RootContainer;
